import { render, staticRenderFns } from "./ClusterView.vue?vue&type=template&id=65e04dc4&scoped=true"
import script from "./ClusterView.vue?vue&type=script&lang=ts"
export * from "./ClusterView.vue?vue&type=script&lang=ts"
import style0 from "./ClusterView.vue?vue&type=style&index=0&id=65e04dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e04dc4",
  null
  
)

export default component.exports